import React from "react";
import { AiOutlineCopy } from "react-icons/ai";
import { IoCloseCircleOutline } from "react-icons/io5";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { toast } from "react-toastify";
import { metaTags } from "../utils";

const SocialShare = ({ url, content, closeModel, closeNotNeed }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);

      toast.success("Copied");
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };
  return (
    <div className="social-icons-share">
      {!closeNotNeed && (
        <IoCloseCircleOutline
          className="svg-icons ml-auto mr-2 mt-2 textWhite"
          onClick={() => closeModel()}
        />
      )}
      <h5 className="font-weight-bold text-black mt-3">
        Share with your friends by using these
      </h5>

      <ul className="social-icons-share p-3 mt-0">
        <li className="text-white">
          <WhatsappShareButton
            url={url}
            title={content}
            separator="  "
            metaTags={metaTags}
          >
            <WhatsappIcon
              size={52}
              round
       
            />
          </WhatsappShareButton>
          Whatsapp
        </li>
        <li className="text-white">
          <TelegramShareButton
            url={url}
            title={content}
            separator="  "
            metaTags={metaTags}
          >
            <TelegramIcon
              size={52}
              round
     
            />
          </TelegramShareButton>
          Telegram
        </li>
        <li className="text-white">
          <LinkedinShareButton
            url={url}
            title={content}
            separator="  "
            metaTags={metaTags}
          >
            <LinkedinIcon
              size={52}
              round

            />
          </LinkedinShareButton>
          Linkedin
        </li>
        <li className="text-white">
          <FacebookShareButton
            url={url}
            title={content}
            separator="  "
            metaTags={metaTags}
          >
            <FacebookIcon
              size={52}
              round

            />
          </FacebookShareButton>
          FaceBook
        </li>
        <li className="text-white">
          <TwitterShareButton
            url={url}
            title={content}
            separator="  "
            metaTags={metaTags}
          >
            <TwitterIcon
              size={52}
              round

            />
          </TwitterShareButton>
          Twitter
        </li>
      </ul>
    </div>
  );
};

export default SocialShare;
